import { TOOLPAD_COMPONENT } from './constants.js';
export default function createComponent(Component, config) {
    return Object.assign(Component, {
        [TOOLPAD_COMPONENT]: config || { argTypes: {} },
    });
}
export function getArgTypeDefaultValue(argType) {
    return argType.typeDef.default ?? argType.defaultValue ?? undefined;
}
